import { useIntl } from "react-intl";
import styled from "styled-components";
import ChevronDown from "src/design-system/icons/ChevronDown.svg?react";
import { A11yOutline } from "src/utils/accessibility";
import { color, fontSize, spacing, fontWeight } from "../../../../../theme";
import messages from "../PassengerPicker.message";

type AgeSelectProps = {
  age: string;
  onChange(age: string): void;
  max: number;
  min?: number;
  id?: string;
};

export function AgeSelect({ age, onChange, max, min = 0, id }: AgeSelectProps) {
  const intl = useIntl();

  return (
    <StyledSelectWrapper width={age.length}>
      <StyledAgeSelect
        value={age}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        id={id}
      >
        <option value="">
          {intl.formatMessage(messages.ageDropdownPlaceholder)}
        </option>

        {Array.from({ length: max - min }, (_, index) => (
          <option key={index + min} value={index + min}>
            {intl.formatMessage(
              index + min === 1
                ? messages.passengerAgeOption
                : messages.passengerAgePluralOption,
              {
                passengerAge: index + min,
              },
            )}
          </option>
        ))}
      </StyledAgeSelect>

      <ChevronWrapper>
        <ChevronDown />
      </ChevronWrapper>
    </StyledSelectWrapper>
  );
}

const StyledSelectWrapper = styled.div<{ width: number }>`
  display: flex;
  border-radius: 16px;
  border: none;
  background-color: ${color.n20};
  cursor: pointer;
  position: relative;

  width: ${({ width }) => {
    switch (width) {
      case 0:
        return "75px";
      case 1:
        return "95px";
      case 2:
        return "105px";
      case 3:
        return "115px";
    }
  }};
`;

const StyledAgeSelect = styled.select`
  right: ${spacing.xl};
  appearance: none;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-weight: ${fontWeight.medium};
  font-size: ${fontSize.h5};
  cursor: inherit;
  line-height: inherit;
  color: black;
  text-align: left;
  padding: ${spacing.sm} ${spacing.lg};
  height: 100%;
  width: 100%;
  pointer-events: auto;

  option {
    background-color: white;
    padding-left: ${spacing.lg};
  }

  ${A11yOutline};
`;

const ChevronWrapper = styled.span`
  // This is a hackyway to make the chevron 'clickable' to open the select menu.
  position: absolute;
  right: 10px;
  top: 3px;
  pointer-events: none;

  svg {
    display: inline-block;
    vertical-align: text-bottom;
    width: ${spacing.xl};
  }
`;
